import createClient from '../../lib/api';

const config = window && window.INITIAL_STATE
    ? Object.assign({ tenant: window.INITIAL_STATE.tenant.subdomain }, window.APP_CONFIG.api)
    : {};

export default createClient(config);
